const style = {
  container: {
    margin: '0 -15px',
    "@media (min-width: 768px)": {
      display: 'flex',
      alignItems: 'center',
    }
  },
  buttonGroup: {
    marginLeft: 8
  },
  orderBtn: {
    padding: '10px 15px 10px 20px'
  },
  orderIco: {
    transition: 'transform .2s ease',
    marginLeft: 8
  },
  rotateIco: {
    transform: 'rotate(180deg)'
  }
}

export default style;
